<template>
	<section class="tp-store-profits-table">
		<StoreProfitsTableReact :profits="profits" :loading="loading" />

		<div class="tp-store-profits-table__total">
			<strong>Lucro total:</strong> {{ calcTotal() | money }}
		</div>
	</section>
</template>
<script>
import ReactInVue from "@/components/logic/wrappers/ReactInVue";
import { StoreProfitsTable } from "@/components/profits/StoreProfitsTable";

const StoreProfitsTableReact = ReactInVue(StoreProfitsTable);

export default {
	components: {
		StoreProfitsTableReact,
	},
	props: {
		profits: {
			type: Array,
			default: () => [],
		},
		loading: {
			type: Boolean,
			default: true,
		},
	},

	methods: {
		calcTotal() {
			let numRepairs = 0;
			let valRepairs = 0;
			let valMaterial = 0;

			for (const item of this.profits) {
				valRepairs += item.totalRepair;
				numRepairs += item.numRepairs;
				valMaterial += item.totalMaterial;
			}

			return (valRepairs - valMaterial * 1.23) * 0.4;
		},
	},
};
</script>

<style lang="scss" scoped>
.tp-store-profits-table {
	margin-bottom: 10px;

	&__total {
		display: block;
		padding: 10px 20px;

		font-size: 1.2rem;
		text-align: right;
	}
}
</style>
